import React from 'react';
import PropTypes from 'prop-types';
import ElementBackground from '../utils/ElementBackground';
import BuildCharacter from './BuildCharacter';
import './BuildBackground.css';

// Constants
const CHARACTER_PLATFORM_IMAGE = '/img/platform.webp';
const CLASS_LOGO_PREFIX = '/img/logo_transparent_';

function getClassLogoImage(characterClass) {
    if (!characterClass?.name) return '';
    return `${CLASS_LOGO_PREFIX}${String(characterClass.name).toLowerCase()}.png`;
}

const BuildBackground = ({
    build,
    onCharacterRenderCaptured = null,
    onCharacterViewChange = null,
    className = "",
}) => {
    const characterClass = build.getCharacterClass();
    const classLogoImage = getClassLogoImage(characterClass);

    return (
        <div className={`build-background ${className}`}>
            <ElementBackground build={build} />
            {classLogoImage ? (
                <div className="build-class-logo-layer" aria-hidden="true">
                    <img
                        src={classLogoImage}
                        className="build-class-logo"
                        alt=""
                    />
                </div>
            ) : null}
            <div className="character-platform-container">
                {/* Color overlay masked by platform alpha */}
                <div
                    className="character-platform-color-overlay"
                    style={{
                        '--platform-image': `url(${CHARACTER_PLATFORM_IMAGE})`
                    }}
                >
                    <ElementBackground build={build} flatColor="start" />
                </div>
                <img
                    src={CHARACTER_PLATFORM_IMAGE}
                    className="character-platform"
                    alt=""
                    aria-hidden="true"
                />
            </div>
            <BuildCharacter
                build={build}
                onRenderCaptured={onCharacterRenderCaptured}
                onViewChange={onCharacterViewChange}
            />
        </div>
    );
};

BuildBackground.propTypes = {
    build: PropTypes.object.isRequired,
    onCharacterRenderCaptured: PropTypes.func,
    onCharacterViewChange: PropTypes.func,
    className: PropTypes.string
};

export default BuildBackground;
